import React, { forwardRef, useCallback, useEffect, useState } from "react";
import { Virtuoso, VirtuosoGrid } from "react-virtuoso";
import classes from "./GridTable.module.css";
import { Box, Checkbox } from "@mui/material";
import { Icon } from "@jds/core";
import Loader from "../UI/Loader/Loader";

const GridTable = ({
  keyValue = "id",
  columns = [],
  rows = [],
  // height,
  onSortModelChange = () => {},
  rowCheckBoxSelction = false,
  onRowCheckBoxChange = () => {},
  lastElement = () => {},
  selectedId = [],
  sortConfigValue = {},
  isLoading = false,
}) => {
  const [selectedRowIds, setSelectedRowIds] = useState([]);

  const [sortConfig, setSortConfig] = useState({
    field: null,
    direction: "asc",
  });

  const handleSort = useCallback(
    (field, sortable) => {
      const newSortConfig =
        sortConfig.field === field
          ? {
              field,
              direction: sortConfig.direction === "asc" ? "desc" : "asc",
            }
          : { field, direction: "asc" };
      onSortModelChange(newSortConfig);
    },
    [sortConfig]
  );

  const handleCheckboxChange = (checked, index, id) => {
    onRowCheckBoxChange(checked, index, id);
  };
  useEffect(() => {
    setSelectedRowIds(selectedId);
  }, [selectedId]);
  useEffect(() => {
    setSortConfig(sortConfigValue);
  }, [sortConfigValue]);
  return (
    <div>
      <div className={`${classes["table-header"]}`}>
        {rowCheckBoxSelction && (
          <div
            className={`${classes["table-header-cell"]}`}
            style={{ width: "50px" }}
          />
        )}
        {columns.map((col) => (
          <div
            key={col.field}
            className={`${classes["table-header-cell"]}`}
            style={{
              flex: col.flex || 1,
              cursor: col.sortable ? "pointer" : "default",
            }}
            onClick={() => handleSort(col.field, col.sortable)}
          >
            <div className={`${classes["header-content"]}`}>
              <span className={`${classes["header-text"]}`}>
                {col.headerName}
              </span>
              {sortConfig.field === col.field && (
                <Box>
                  {sortConfig.direction === "asc" ? (
                    <Box
                      sx={{
                        "--color-primary-50": "white",
                      }}
                    >
                      <Icon ic={"IcChevronUp"} />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        "--color-primary-50": "white",
                      }}
                    >
                      <Icon ic={"IcChevronDown"} />
                    </Box>
                  )}
                </Box>
              )}
            </div>
          </div>
        ))}
      </div>
      <Virtuoso
        style={{
          height: "calc(100vh - 405px)",
        }}
        className="custom-scrollbar"
        data={rows}
        endReached={() => {
          lastElement();
        }}
        increaseViewportBy={10}
        itemContent={(index, item) => {
          return (
            <RowElement
              index={index}
              keyValue={keyValue}
              row={item}
              columns={columns}
              showCheckbox={rowCheckBoxSelction}
              isChecked={selectedRowIds.includes(item[keyValue])}
              onCheckChange={handleCheckboxChange}
            />
          );
        }}
        components={{ Footer: isLoading ? Footer : "" }}
      />
    </div>
  );
};

const Footer = () => {
  return (
    <Loader size="small" containerProps={{ style: { marginTop: "16px" } }} />
  );
};
const RowElement = React.memo(
  ({
    index,
    keyValue = "id",
    row = {},
    columns = [],
    showCheckbox = false,
    isChecked,
    onCheckChange,
  }) => {
    const rowClassName = `${classes["table-row"]} ${
      isChecked ? classes["selected"] : ""
    }`;

    return (
      <div className={rowClassName} key={index}>
        {showCheckbox && (
          <div
            className={`${classes["table-data-cell"]} ${classes["checkbox-cell"]}`}
            style={{ width: "50px" }}
          >
            <Checkbox
              size="small"
              checked={isChecked}
              onChange={(e) =>
                onCheckChange(e.target.checked, index, row[keyValue])
              }
            />
          </div>
        )}
        {columns.map((col) => (
          <div
            key={col.field}
            className={`${classes["table-data-cell"]}`}
            style={{ flex: col.flex || 1 }}
          >
            {col.renderCell ? (
              col.renderCell({ row, index })
            ) : (
              <span className={classes["wrap-ellipsis"]} title={row[col.field]}>
                {row[col.field]}
              </span>
            )}
          </div>
        ))}
      </div>
    );
  }
);

export default GridTable;
